import { render, staticRenderFns } from "./BeforeLoginLayout.vue?vue&type=template&id=550ef1f4&scoped=true&"
import script from "./BeforeLoginLayout.vue?vue&type=script&lang=ts&"
export * from "./BeforeLoginLayout.vue?vue&type=script&lang=ts&"
import style0 from "./BeforeLoginLayout.vue?vue&type=style&index=0&id=550ef1f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550ef1f4",
  null
  
)

export default component.exports